import { Component, Input, OnInit } from '@angular/core';
import {
  PrismicUtils,
  SuraBreadcrumbService,
} from '@segurosvoluntarios_vel/commons-services';
import { BaseEstadoPagoComponent } from 'src/app/pago/containers/estado-pago/base-estado/base-estado-pago.component';
import { IdProducto } from 'src/app/pago/enums/IdProducto.enum';
import { ConfiguracionDePago } from 'src/app/pago/models/ConfiguracionDePago.model';
import { ContenidoDeEstadoDePago } from 'src/app/pago/models/ContenidoDeEstadoDePago.model';
import { Pago } from 'src/app/pago/models/Pago.model';
import { PagoFacade } from 'src/app/pago/services/pago-facade/pago.facade';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-aprobado',
  templateUrl: './aprobado.component.html',
  styleUrls: [
    './aprobado.component.scss',
    '../base-estado/base-estado-pago.component.scss',
  ],
})
export class AprobadoComponent extends BaseEstadoPagoComponent
  implements OnInit {
  @Input() pago: Pago;
  @Input() contenido: ContenidoDeEstadoDePago;
  @Input() tenant: string;
  urlConsultaSoat: string;
  idProducto: string;

  constructor(
    public prismicUtils: PrismicUtils,
    public pagoFacade: PagoFacade,
    public suraBreadcrumbService: SuraBreadcrumbService
  ) {
    super(prismicUtils);
    this.suraBreadcrumbService.setStep(4); // hace referencia a que los 3 pasos fueron completados [cotizacion, datos, pago]
  }
  ngOnInit(): void {
    this.inicializar(this.pago, this.contenido, this.tenant);
    this.subscribeToConfiguracionDePago();
    this.urlConsultaSoat = `${environment.suraPath}/v2/${this.tenant}/soat/consulta-tu-soat`;
  }

  subscribeToConfiguracionDePago() {
    this.pagoFacade.configuracionDePago$.subscribe(
      (configuracionDePago: ConfiguracionDePago) => {
        this.idProducto = configuracionDePago.idProducto;
      }
    );
  }

  isSoat(): boolean {
    return this.pago.idProducto === IdProducto.PRODUCTO_SOAT_FLUJO_VENTA;
  }
}
